export const ASYNC_ADD = 'ASYNC_ADD';
export const ASYNC_DELETE = 'ASYNC_DELETE';
export const SET_MOBILE = 'SET_MOBILE';